import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PlatformRedFlagListScreen } from '@/features/red-flags/components/platform/RedFlagListScreen';
import { requirePermission } from '@/lib/guards';

const searchSchema = z.object({
  // An unknown value (a hand-edited or stale link) shows all flags instead of crashing.
  status: z.enum(['open', 'under_review', 'closed']).optional().catch(undefined),
});

export const Route = createFileRoute('/_staff/admin/platform/red-flags/')({
  validateSearch: (input) => searchSchema.parse(input),
  beforeLoad: () => {
    requirePermission('red_flag:read');
  },
  component: PlatformRedFlagListScreen,
  staticData: { crumb: 'Red flags' },
});
